//Plantilla de archivo de store
const namespaced = true
import api from '../../../api/industrialReveal/Industrial_reveal.js';

const state = {
    infoIotValue: [],
    loadingIot: false,
    measurePointList: [],
    catalogInfo: [],
    loadingCatalog: false,
    mpc_info: [],
    loading_mpc: false,
}
const mutations = {
    SET_DELAY_IOT_INFO(state, data) {
        state.infoIotValue = data;
    },
    SET_LOADING(state, data) {
        state.loadingIot = data;
    },
    SET_MEASURE_POINT_LIST(state, data) {
        state.measurePointList = data;
    },
    SET_CATALOG_INFO(state, data) {
        state.catalogInfo = data;
    },
    SET_LOADING_CATALOG(state, data) {
        state.loadingCatalog = data;
    },
    SET_MPC_INFO(state, data) {
        state.mpc_info = data;
    },
    SET_LOADING_MPC(state, value) {
        state.loading_mpc = value;
    },
}
const actions = {
    getDelayIotEvent(context, data) {
        context.commit('SET_LOADING', true);
        return new Promise((resolve) => {
            api.getIotDelayEvent(data).then(function (res) {
                context.commit('SET_DELAY_IOT_INFO', res.data.data);
                resolve(res);
                context.commit('SET_LOADING', false);
            }).catch((e) => {
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
                context.commit('SET_LOADING', false);
            })
        })
    },

    syncData(context) {
        context.commit('SET_LOADING', true);
        return new Promise((resolve) => {
            api.syncData().then(function (res) {
                context.commit('SET_DELAY_IOT_INFO', res.data.data);
                resolve(res);
                context.commit('SET_LOADING', false);
                context.dispatch('notifications/add', { 'color': 'success', 'visibility': true, 'timeout': 5000, 'text': 'Se insertaron ' + res.data.metadata.totalItems + ' registros nuevos' }, { root: true });
            }).catch((e) => {
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
                context.commit('SET_LOADING', false);
            })
        })
    },
    getMeasuringPoints(context) {
        context.commit('SET_LOADING', true);
        return new Promise((resolve) => {
            api.getMeasuringPoints().then(function (res) {
                context.commit('SET_MEASURE_POINT_LIST', res.data.data);
                resolve(res);
                context.commit('SET_LOADING', false);
                context.dispatch('notifications/add', { 'color': 'success', 'visibility': true, 'timeout': 5000, 'text': res.data.message }, { root: true });
            }).catch((e) => {
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
                context.commit('SET_LOADING', false);
            })
        })
    },

    getCatalogMeasurePoint(context) {
        context.commit('SET_LOADING_CATALOG', true);
        return new Promise((resolve) => {
            api.getCatalogMeasurePoint().then(function (res) {
                context.commit('SET_CATALOG_INFO', res.data.data);
                resolve(res);
                context.commit('SET_LOADING_CATALOG', false);
            }).catch((e) => {
                context.commit('SET_LOADING_CATALOG', false);
                console.log(e);
            })
        })
    },
    setNewMeasurePoint(context, data) {
        context.commit('SET_LOADING', true);
        return new Promise((resolve) => {
            api.setNewMeasurePoint(data).then(function (res) {
                context.commit('SET_MEASURE_POINT_LIST', res.data.data);
                resolve(res);
                context.commit('SET_LOADING', false);
                context.dispatch('notifications/add', { 'color': 'success', 'visibility': true, 'timeout': 5000, 'text': res.data.message }, { root: true });
            }).catch((e) => {
                context.commit('SET_LOADING', false);
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e }, { root: true });
            })
        })
    },
    updateMeasurePoint(context, data) {
        context.commit('SET_LOADING', true);
        return new Promise((resolve) => {
            api.updateMeasurePoint(data.id, data.data).then(function (res) {
                context.commit('SET_MEASURE_POINT_LIST', res.data.data);
                resolve(res);
                context.commit('SET_LOADING', false);
                context.dispatch('notifications/add', { 'color': 'success', 'visibility': true, 'timeout': 5000, 'text': res.data.message }, { root: true });
            }).catch((e) => {
                context.commit('SET_LOADING', false);
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
            })
        })
    },
    getDelayMeasurePointInfo(context, id) {
        context.commit("SET_LOADING_MPC", true);
        return new Promise((resolve) => {
            api.getDelayMeasurePointInfo(id).then(function (res) {
                context.commit("SET_MPC_INFO", res.data.data);
                context.commit("SET_LOADING_MPC", false);
                resolve(res.data);
            })
                .catch(function (error) {
                    context.commit("SET_LOADING_MPC", false);
                    console.log(error);
                });
        });
    },
    deleteMeasurePointInfo(context) {
        context.commit("SET_MPC_INFO", []);
    },
    deleteDelayMeasurePoint(context, id) {
        context.commit("SET_LOADING", true);
        return new Promise((resolve) => {
            api.deleteDelayMeasurePoint(id).then(function (res) {
                context.commit("SET_MEASURE_POINT_LIST", res.data.data);
                context.commit("SET_LOADING", false);
                resolve(res.data);
                context.dispatch("notifications/add", { color: "success", visibility: true, timeout: 5000, text: res.data.message, }, { root: true });
            }).catch(function (error) {
                context.commit("SET_LOADING", false);
                console.log(error);
                context.dispatch("notifications/add", { color: "error", visibility: true, timeout: 5000, text: error.messages, }, { root: true });
            });
        });
    },
}
const getters = {
    getIotValue(state) {
        return state.infoIotValue;
    },
    getMeasurePointValue(state) {
        return state.measurePointList;
    },
    getCatalogInfo(state) {
        return state.catalogInfo;
    },
}
export default {
    namespaced,
    state,
    mutations,
    actions,
    getters,
}